/* unplugin-vue-components disabled */import { ElDialog as __unplugin_components_8 } from 'element-plus/es';import 'element-plus/es/components/dialog/style/css';
import { ElForm as __unplugin_components_7 } from 'element-plus/es';import 'element-plus/es/components/form/style/css';
import { ElTag as __unplugin_components_6 } from 'element-plus/es';import 'element-plus/es/components/tag/style/css';
import { ElDatePicker as __unplugin_components_5 } from 'element-plus/es';import 'element-plus/es/components/date-picker/style/css';
import { ElButton as __unplugin_components_4 } from 'element-plus/es';import 'element-plus/es/components/button/style/css';
import { ElInput as __unplugin_components_3 } from 'element-plus/es';import 'element-plus/es/components/input/style/css';
import { ElFormItem as __unplugin_components_2 } from 'element-plus/es';import 'element-plus/es/components/form-item/style/css';
import { ElRadioGroup as __unplugin_components_1 } from 'element-plus/es';import 'element-plus/es/components/radio-group/style/css';
import { ElRadio as __unplugin_components_0 } from 'element-plus/es';import 'element-plus/es/components/radio/style/css';
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, isRef as _isRef, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-4c67ce5d"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "tips",
  style: {
    "margin-bottom": "10px",
    "color": "#faad14"
  }
};
const _hoisted_2 = {
  class: "flex width100"
};
const _hoisted_3 = {
  key: 3,
  class: "tips-container"
};
const _hoisted_4 = {
  style: {
    "font-weight": "700"
  }
};
const _hoisted_5 = {
  style: {
    "font-weight": "700"
  }
};
const _hoisted_6 = {
  style: {
    "font-weight": "700"
  }
};
const _hoisted_7 = {
  style: {
    "font-weight": "700",
    "margin-right": "10px"
  }
};
const _hoisted_8 = {
  class: "dialog-footer"
};
import dayjs from 'dayjs';
import { apiUsdkCpsPublishCdn, apiUsdkCpsCancelCdn } from '@/api/usdk';
export default /*#__PURE__*/_defineComponent({
  __name: 'publishCdnDialog',
  emits: ['success'],
  setup(__props, {
    expose,
    emit: emits
  }) {
    const resetDisabled = ref(false);
    const dialogVisible = ref(false);
    const cdnConfirmLoading = ref(false);
    const cdnRuleForm = ref();
    const cdnType = ref(1);
    const cdnForm = ref({
      isCancelCdn: 1,
      cdnUrl: '',
      cdnTime: '',
      recordId: '',
      packageInfo: {
        verName: '',
        verCode: '',
        sdkVersion: '',
        pkgTime: ''
      }
    });
    const resetUrl = ref('');
    const selectedRowKeys = ref([]);
    const initForm = () => {
      cdnForm.value = {
        isCancelCdn: 1,
        cdnUrl: '',
        cdnTime: '',
        recordId: '',
        packageInfo: {
          verName: '',
          verCode: '',
          sdkVersion: '',
          pkgTime: ''
        }
      };
    };
    // 不能选的日期
    const disabledDate = current => {
      return current && current < dayjs().startOf('days');
    };
    const handleChangeCdnUrl = () => {
      resetDisabled.value = false;
    };
    const handleOk = formEl => {
      if (!formEl) return;
      formEl.validate(valid => {
        if (valid) {
          cdnConfirmLoading.value = true;
          if (cdnType.value === 2) {
            // 批量发布cdn
            const params = {
              recordIds: selectedRowKeys.value.join(','),
              cdnTime: cdnForm.value.cdnTime ? cdnForm.value.cdnTime : null
            };
            apiUsdkCpsPublishCdn(params).then(res => {
              if (res.code === 0) {
                emits('success');
                handleClose(cdnRuleForm.value);
              }
            }).finally(() => {
              cdnConfirmLoading.value = false;
            });
          } else if (cdnType.value === 1) {
            // 单个发布cdn, 失败重新发布cdn
            const params = {
              recordIds: cdnForm.value.recordId,
              cdnUrl: cdnForm.value.cdnUrl,
              cdnTime: cdnForm.value.cdnTime ? cdnForm.value.cdnTime : null
            };
            apiUsdkCpsPublishCdn(params).then(res => {
              if (res.code === 0) {
                emits('success');
                handleClose(cdnRuleForm.value);
              }
            }).finally(() => {
              cdnConfirmLoading.value = false;
            });
          } else if (cdnType.value === 3) {
            // 重新编辑cdn
            if (cdnForm.value.isCancelCdn === 2) {
              const params = {
                recordId: cdnForm.value.recordId
              };
              apiUsdkCpsCancelCdn(params).then(res => {
                if (res.code === 0) {
                  emits('success');
                  handleClose(cdnRuleForm.value);
                }
              }).finally(() => {
                cdnConfirmLoading.value = false;
              });
            } else {
              const params = {
                recordIds: cdnForm.value.recordId,
                cdnUrl: cdnForm.value.cdnUrl,
                cdnTime: cdnForm.value.cdnTime ? cdnForm.value.cdnTime : null
              };
              apiUsdkCpsPublishCdn(params).then(res => {
                if (res.code === 0) {
                  emits('success');
                  handleClose(cdnRuleForm.value);
                }
              }).finally(() => {
                cdnConfirmLoading.value = false;
              });
            }
          }
        }
      });
    };
    const handleReset = () => {
      cdnForm.value.cdnUrl = resetUrl.value;
      resetDisabled.value = false;
    };
    const computingTime = time => {
      let nowDate = new Date().getTime();
      let oldDate = dayjs(time).valueOf();
      let res = Math.floor((nowDate - oldDate) / 3600000);
      if (res === 0) {
        return '小于一小时';
      } else if (res > 0 && res < 24) {
        return `${res}小时前`;
      } else if (res > 24) {
        let day = Math.floor(res / 24);
        return `${day}天前`;
      }
    };
    const handleConfirmCdnUrl = (rule, value, callback) => {
      // eslint-disable-next-line no-control-regex
      const reg = /[^\x00-\xff]/igm;
      if (value && reg.test(value)) {
        callback('CDN地址不支持中文符号');
      }
      callback();
    };
    const handleClose = formEl => {
      if (!formEl) return;
      dialogVisible.value = false;
      formEl.resetFields();
      initForm();
    };
    const show = (type, data, mul) => {
      dialogVisible.value = true;
      cdnType.value = type;
      if (data) {
        cdnForm.value = {
          ...data,
          cdnTime: data.cdnTime + ':00'
        };
        resetUrl.value = data.cdnUrl;
      }
      if (mul) {
        selectedRowKeys.value = mul.map(item => item.recordId);
      }
      if (data.cdnStatus !== 5) {
        const t = new Date();
        const t_s = t.getTime();
        t.setTime(t_s + 1000 * 120);
        cdnForm.value.cdnTime = dayjs(t).format('YYYY-MM-DD HH:mm:ss');
      }
    };
    expose({
      show
    });
    return (_ctx, _cache) => {
      const _component_el_radio = __unplugin_components_0;
      const _component_el_radio_group = __unplugin_components_1;
      const _component_el_form_item = __unplugin_components_2;
      const _component_el_input = __unplugin_components_3;
      const _component_el_button = __unplugin_components_4;
      const _component_el_date_picker = __unplugin_components_5;
      const _component_el_tag = __unplugin_components_6;
      const _component_el_form = __unplugin_components_7;
      const _component_el_dialog = __unplugin_components_8;
      return _openBlock(), _createBlock(_component_el_dialog, {
        title: "发布CDN",
        modelValue: _unref(dialogVisible),
        "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => _isRef(dialogVisible) ? dialogVisible.value = $event : null),
        width: "600px",
        "before-close": () => handleClose(_unref(cdnRuleForm))
      }, {
        footer: _withCtx(() => [_createElementVNode("span", _hoisted_8, [_createVNode(_component_el_button, {
          onClick: _cache[3] || (_cache[3] = $event => handleClose(_unref(cdnRuleForm)))
        }, {
          default: _withCtx(() => [_createTextVNode("取消")]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          loading: _unref(cdnConfirmLoading),
          onClick: _cache[4] || (_cache[4] = $event => handleOk(_unref(cdnRuleForm)))
        }, {
          default: _withCtx(() => [_createTextVNode("确认")]),
          _: 1
        }, 8, ["loading"])])]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, " 您正在" + _toDisplayString(_unref(cdnType) === 2 ? '批量' : '') + "发布CDN！发布成功后，链接会在公网即时生效，请确认已上线链接是否指向正确的包！ ", 1), _createVNode(_component_el_form, {
          model: _unref(cdnForm),
          ref_key: "cdnRuleForm",
          ref: cdnRuleForm,
          "label-width": "120px"
        }, {
          default: _withCtx(() => [_unref(cdnType) === 3 ? (_openBlock(), _createBlock(_component_el_form_item, {
            key: 0,
            prop: "isCancelCdn",
            label: "CDN发布"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_radio_group, {
              modelValue: _unref(cdnForm).isCancelCdn,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _unref(cdnForm).isCancelCdn = $event)
            }, {
              default: _withCtx(() => [_createVNode(_component_el_radio, {
                label: 1
              }, {
                default: _withCtx(() => [_createTextVNode("定时发布")]),
                _: 1
              }), _createVNode(_component_el_radio, {
                label: 2
              }, {
                default: _withCtx(() => [_createTextVNode("取消发布CDN")]),
                _: 1
              })]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          })) : _createCommentVNode("", true), _unref(cdnType) !== 2 && _unref(cdnForm).isCancelCdn !== 2 ? (_openBlock(), _createBlock(_component_el_form_item, {
            key: 1,
            prop: "cdnUrl",
            label: "CDN地址",
            rules: [{
              required: true,
              message: '请输入CDN地址',
              trigger: 'blur'
            }, {
              required: true,
              message: '地址格式错误',
              pattern: /^(http(s?)|):\/\/(.+)$/
            }, {
              validator: handleConfirmCdnUrl
            }]
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_input, {
              class: "width100",
              modelValue: _unref(cdnForm).cdnUrl,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _unref(cdnForm).cdnUrl = $event),
              onChange: handleChangeCdnUrl,
              placeholder: "请输入CDN地址"
            }, null, 8, ["modelValue"]), _createVNode(_component_el_button, {
              disabled: _unref(resetDisabled),
              class: "marginL10",
              onClick: handleReset
            }, {
              default: _withCtx(() => [_createTextVNode("重置")]),
              _: 1
            }, 8, ["disabled"])])]),
            _: 1
          }, 8, ["rules"])) : _createCommentVNode("", true), _unref(cdnForm).isCancelCdn !== 2 ? (_openBlock(), _createBlock(_component_el_form_item, {
            key: 2,
            style: {
              "margin-bottom": "5px"
            },
            prop: "cdnTime",
            label: "发布时间",
            rules: {
              required: true,
              message: '请选择发布时间',
              trigger: 'change'
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_el_date_picker, {
              modelValue: _unref(cdnForm).cdnTime,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _unref(cdnForm).cdnTime = $event),
              type: "datetime",
              disabledDate: disabledDate,
              placeholder: "请选择发布时间",
              "value-format": "YYYY-MM-DD HH:mm"
            }, null, 8, ["modelValue"])]),
            _: 1
          })) : _createCommentVNode("", true), _unref(cdnType) !== 2 ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createVNode(_component_el_form_item, {
            label: "VersionName"
          }, {
            default: _withCtx(() => [_createElementVNode("span", _hoisted_4, _toDisplayString(_unref(cdnForm).packageInfo && _unref(cdnForm).packageInfo.verName), 1)]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "VersionCode"
          }, {
            default: _withCtx(() => [_createElementVNode("span", _hoisted_5, _toDisplayString(_unref(cdnForm).packageInfo && _unref(cdnForm).packageInfo.verCode), 1)]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "SDK"
          }, {
            default: _withCtx(() => [_createElementVNode("span", _hoisted_6, _toDisplayString(_unref(cdnForm).packageInfo && _unref(cdnForm).packageInfo.sdkVersion), 1)]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "打包时间"
          }, {
            default: _withCtx(() => [_createElementVNode("span", _hoisted_7, _toDisplayString(_unref(cdnForm).packageInfo && _unref(cdnForm).packageInfo.pkgTime), 1), _createVNode(_component_el_tag, {
              color: "orange",
              style: {
                "color": "#fff"
              }
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(computingTime(_unref(cdnForm).packageInfo && _unref(cdnForm).packageInfo.pkgTime)), 1)]),
              _: 1
            })]),
            _: 1
          })])) : _createCommentVNode("", true)]),
          _: 1
        }, 8, ["model"])]),
        _: 1
      }, 8, ["modelValue", "before-close"]);
    };
  }
});